<template>
  <div
    class="main__content"
  >
    <div class="input-row buttons-group buttons-group--align-center">
      <CamsButton
        priority="primary"
        type="button"
        size="m"
        @click="confirmSelection"
      >
        Выбрать камеры ({{ selectionLabel }})
      </CamsButton>
      <CamsButton
        priority="secondary"
        type="button"
        size="m"
        @click="closeDialog"
      >
        Отмена
      </CamsButton>
    </div>
    <SpinnerLoading v-if="isLoadingTable || isLoadingCameras" class="loader_center" color="blue" />
    <PacsTable
      v-else
      :column-captions="columnCaptions"
      :initial-selected-keys="selectedCameraKeys"
      :column-names="columnNames"
      :data-rows="dataRows"
      :page-count="pageCount"
      :key-field="keyField"
      :sort-info="sortInfo"
      :total-count="totalCount"
      :current-page="currentPage"
      @new-page="selectPage"
      @new-sort="changeSort"
      @new-entities-for-multi-edit="onSelectedEntitiesChange"
    />
  </div>
</template>

<script>
import PacsTable from "@/components/pacs/PacsTable.vue";
import {
  ACTION_LOAD_PEOPLE_COUNT_ANALYTICS_FOR_TABLE,
  CAMERA_ANALYTICS_STRUCT_PEOPLE_COUNT
} from "@/store/analytics/index.js";
import {createEntityMixin, entityTableMixin, methodsForDialogMixin} from "@/components/pacs/mixins.js";
import {
  ACTION_LOAD_CAMERAS,
  FIELDS_CAMERA
} from "@/store/cameras/index.js";

/**
 * Компонент отображения таблицы камер с аналитикой по вторжению зоны.
 */
export default {
  name: "AddCameraToReportDialog",
  mixins: [
    entityTableMixin,methodsForDialogMixin
  ],
  props: {
    initialSelectedCameraNumbers: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    PacsTable
  },

  data() {
    return {
      entityStruct: CAMERA_ANALYTICS_STRUCT_PEOPLE_COUNT,
      disableRouteSync: true,
      entityFields: [
        CAMERA_ANALYTICS_STRUCT_PEOPLE_COUNT.fields.camera_number,
        {
          name: 'camera_title',
          title: 'Название камеры',
          type: 'string'
        },
        {
          name: 'camera_address',
          title: 'Адрес камеры',
          type: 'string'
        }
      ],
      isLoadingCameras: false,
      selectedCameraKeys: [...this.initialSelectedCameraNumbers], // ← стартуем с уже выбранных
      camerasInfo: {}
    };
  },
  computed: {
    selectionLabel() {
      if (this.selectedCameraKeys === true) {
        return 'все по фильтру';
      }
      if (Array.isArray(this.selectedCameraKeys)) {
        return this.selectedCameraKeys.length || 0;
      }
      return 0;
    },
  },
  methods: {
    /**
     * Загружает информацию о камерах по их номерам
     */
    async loadCamerasInfo(cameraNumbers) {
      if (!cameraNumbers || cameraNumbers.length === 0) {
        this.camerasInfo = {};
        return;
      }

      this.isLoadingCameras = true;
      try {
        const response = await this.$store.dispatch(`cameras/${ACTION_LOAD_CAMERAS}`, {
          fields: [
            FIELDS_CAMERA.number,
            FIELDS_CAMERA.address,
            FIELDS_CAMERA.title,
            FIELDS_CAMERA.timezone,
            FIELDS_CAMERA.analytics,
            FIELDS_CAMERA.is_public,
            FIELDS_CAMERA.inactivity_period,
            FIELDS_CAMERA.server,
            FIELDS_CAMERA.token_l,
            FIELDS_CAMERA.tariff,
            FIELDS_CAMERA.permission
          ],
          numbers: cameraNumbers,
        });

        // Преобразуем массив в объект для быстрого доступа по номеру камеры
        this.camerasInfo = response.reduce((acc, camera) => {
          acc[camera[FIELDS_CAMERA.number]] = {
            title: camera[FIELDS_CAMERA.title],
            address: camera[FIELDS_CAMERA.address]
          };
          return acc;
        }, {});

      } catch (error) {
        console.error('Ошибка при загрузке информации о камерах:', error);
        this.camerasInfo = {};
      } finally {
        this.isLoadingCameras = false;
      }
    },
    confirmSelection() {
      this.closeDialog({
        selectedCameraKeys: this.selectedCameraKeys,
        searchText: this.searchText || null,
      });
    },
    onSelectedEntitiesChange(value) {
      // value может быть:
      // - Array (список _key_ выбранных строк по всем страницам)
      // - true (если пользователь нажал "Выбрать все")
      this.selectedCameraKeys = value;
      // Здесь же можешь пробрасывать дальше вверх через $emit,
      // если TablePeopleCounter — это вложенный компонент диалога.
    },

    async loadPage() {
      this.isLoadingTable = true;
      try {
        const responseData = await this.$store.dispatch(`analytics/${ACTION_LOAD_PEOPLE_COUNT_ANALYTICS_FOR_TABLE}`, {
          search: this.searchText,
          page: this.currentPage,
          pageSize: 10,
        });

        this.pageCount = responseData.page.all;
        this.totalCount = responseData.count;

        const cameraNumbers = responseData.results.map(
          row => row[CAMERA_ANALYTICS_STRUCT_PEOPLE_COUNT.fields.camera_number.name]
        );

        await this.loadCamerasInfo(cameraNumbers);

        this.dataRows = responseData.results.map((rawMaskInfo) => {
          const cameraNumber = rawMaskInfo[CAMERA_ANALYTICS_STRUCT_PEOPLE_COUNT.fields.camera_number.name];
          const cameraInfo = this.camerasInfo[cameraNumber] || {title: 'Не найдено', address: 'Не указан'};

          return {
            ...this.calcDefaultDataRow(rawMaskInfo),
            [CAMERA_ANALYTICS_STRUCT_PEOPLE_COUNT.fields.camera_number.name]: {
              value: cameraNumber,
            },
            camera_title: {
              type: 'string',
              value: cameraInfo.title
            },
            camera_address: {
              type: 'string',
              value: cameraInfo.address
            }
          };
        });
      } catch (error) {
        console.error('Ошибка при загрузке страницы:', error);
      } finally {
        this.isLoadingTable = false;
      }
    },
  },
};
</script>
